import { Navigate, useParams } from 'react-router-dom';
import { useUsersStore } from 'services/users';
import { ReactNode } from 'react';

interface SpecialistActiveGuardProps {
  children: ReactNode;
}

/**
 * A guard component that checks if a specialist is active
 * If not, it redirects them to the specialist-switcher page
 */
export const SpecialistActiveGuard = ({ children }: SpecialistActiveGuardProps) => {
  const { user, loading } = useUsersStore();
  const { language } = useParams();

  // Wait for user data to load
  if (loading) {
    return null;
  }

  // If user is a specialist and not active, redirect to specialist-switcher
  if (user && user.role === 'SPECIALIST' && user.is_active === false) {
    return <Navigate to={`/${language || 'en'}/specialist-switcher`} />;
  }

  // Otherwise, render children
  return <>{children}</>;
}; 